










































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Select2 } from '@/components/form'
import { DatePicker } from '@/components/general'
import TableNewDailyControls from './TableNewDailyControls.vue'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

// models
import { DailyControlForm, DailyControlTablePreview } from '@/models/dailyControl'
import { IEmployee, WorkDescriptionModel } from '@/models/config'
import { PropOptionSelect } from '@/models'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'
import { getListDateAvailable } from '@/utils/employee'

// services
import { DailyControlsService } from '@/services/dailyControl'

@Component({
    name: 'FormCreateEditDailyControl',
    components: {
        Input,
        Select2,
        DatePicker,
        TableNewDailyControls
    },
    mixins: [validationMixin]
})
export default class FormCreateEditDailyControl extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) dailyControl!: DailyControlForm
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ type: Array, default: () => [] }) employees!: IEmployee[]
    @Prop({ type: Array, default: () => [] }) workDescriptions!: WorkDescriptionModel[]

    WorkDescriptionSelected!: WorkDescriptionModel
    newItems: DailyControlForm[] = []
    newItemsPreview: DailyControlTablePreview[] = []
    form: DailyControlForm = {
        price: 0,
        date: '',
        employee_id: null,
        work_description_id: null,
        amount: 1,
        total: 0
    }

    dateAvailable: string[] = []

    get employeeSelected (): IEmployee | null {
        if (this.form.employee_id && this.employeesOp.find(employee => employee.value === this.form.employee_id)) {
            const employee = this.employees.find(e => e.id === this.form.employee_id)
            if (employee) {
                return employee
            }
        }
        return null
    }

    get total (): number {
        const total = parseFloat(String(this.form.price)) * this.form.amount
        this.form.total = total
        return parseFloat(parseFloat(String(total)).toFixed(2))
    }

    get descriptionsOp (): PropOptionSelect[] {
        return this.workDescriptions.map(w => {
            return {
                value: w.id,
                text: w.name
            }
        })
    }

    get employeesOp (): PropOptionSelect[] {
        return this.employees.map(employee => {
            return {
                value: employee.id ?? null,
                text: getFullNameFormat(employee)
            }
        })
    }

    get canAdd (): boolean {
        return !this.$v.$anyError && this.isFormValid()
    }

    created () {
        if (this.idEdit) {
            this.form = this.dailyControl
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                price: { required },
                date: { required },
                employee_id: { required },
                work_description_id: { required },
                amount: { required }
            }
        }
    }

    isFormValid (): boolean {
        if (this.form.amount < 1) {
            return false
        }
        const itemAdded = this.newItems.find(item => item.date === this.form.date && item.work_description_id === this.form.work_description_id)
        if (itemAdded) {
            return false
        }
        return true
    }

    initForm () {
        this.form.work_description_id = null
        this.form.date = ''
    }

    addItem () {
        if (!this.$v.$anyError) {
            const item = {
                ...this.form
            }
            this.newItems.push(item)
            this.newItemsPreview.push({
                date: this.form.date,
                employee: `${this.employees.find(e => e.id === this.form.employee_id)?.name} ${this.employees.find(e => e.id === this.form.employee_id)?.last_name}` || '',
                description: this.WorkDescriptionSelected.name,
                price: this.form.price,
                amount: this.form.amount,
                total: this.total
            })
            this.initForm()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
    }

    isValid (): boolean {
        for (let i = 0; i < this.newItems.length; i++) {
            const element = this.newItems[i]
            if (!element.employee_id) {
                return false
            }
        }
        return true
    }

    async save () {
        this.$v.$touch()
        if (this.isValid()) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await DailyControlsService.update(this.idEdit, this.form)
                } else {
                    for (let i = 0; i < this.newItems.length; i++) {
                        const element = this.newItems[i]
                        await DailyControlsService.create(element)
                    }
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    price: 0,
                    date: '',
                    employee_id: null,
                    work_description_id: null,
                    amount: 0,
                    total: 0
                }
                this.newItems = []
                this.newItemsPreview = []
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    changeDescription () {
        const workDescription = this.workDescriptions.find(work => work.id === this.form.work_description_id)
        if (workDescription) {
            this.WorkDescriptionSelected = workDescription
            this.form.price = workDescription.price
        }
        this.form.amount = 1
    }

    setListDateAvailable () {
        if (this.form.employee_id && this.employeeSelected) {
            const listDate = getListDateAvailable(this.employeeSelected.cessation)
            this.dateAvailable = listDate
        }
    }
}
